export default function getDealershipIdFromPathname(
  pathname: string
): string | null {
  return pathname.match(/^\/dealership\/([^/]+)/)?.[1] ?? null;
}
